
import Vue from 'vue';

import { CvHeader, CvHeaderName, CvIconButton } from '@carbon/vue';

import ArrowLeft20 from '@carbon/icons-vue/es/arrow--left/20';

export default Vue.extend({
  name: 'PinturaHeader',
  components: {
    CvHeader,
    CvHeaderName,
    CvIconButton,
    ArrowLeft20,
  },
  props: {
    buttonLabel: {
      type: String,
      default: '',
    },
  },
  methods: {
    sendEvent() {
      this.$emit('wizard:back-button-click');
    },
  },
});
